const selectDeviceModelOutputs = state => state.data.deviceModelOutputs

const DeviceModelOutputDataStoreSelectors = {
  deviceModelOutputs: selectDeviceModelOutputs
}

export default DeviceModelOutputDataStoreSelectors
